<template>
  <iframe
    :src="qrcodeUrl"
    class="qrframe"
    frameborder="0"
    scrolling="no"
  ></iframe>    
</template>

<style scoped lang="scss">
.refresh {
  margin: auto;
  cursor: pointer;
}
</style>

<script>
export default {
  data() {
    return {
      qrcodeUrl: "",
    };
  },
  methods: {
    getQRcode() {
      this.$http.get("/login").then((response) => {
        this.qrcodeUrl = response.data.url;
      });
    },
    login(code, sessionId) {
      this.$http
        .post("/login", {
          code: code,
          session_id: sessionId,
        })
        .then((response) => {
          location.reload();
          this.$store.commit("login", response.data);
          window.removeEventListener("message", this.handleLoginEvent);
          this.$router.push({
            name: "Home",
            params: { locale: this.$i18n.locale },
          });
        });
    },
    handleLoginEvent(event) {
      if (typeof event.data === "string" && event.data.includes("success")) {
        const url = new URL(event.data);
        const code = url.searchParams.get("code");
        const session = url.pathname.split("/");
        const sessionId = session[session.length - 1];

        this.login(code, sessionId);
      }
    }
  },
  mounted() {
    this.getQRcode();
    window.addEventListener("message", this.handleLoginEvent);
  },
};
</script>
